import arrowRightSrc from '@raison/static/icons/arrow-right-line.svg';
import arrowLinkSrc from '@raison/static/icons/arrow-right-up-line.svg';
import React, {FC, ReactNode} from 'react';
import {ModifierClasses} from '../shared/types';
import scss from './RsnBadge.module.scss';

type Modifier<S extends string> = ModifierClasses<S, typeof scss>;

export interface RsnBadgeProps {
    children?: ReactNode;
    className?: string;
    color?: Modifier<'color'>;
    decoration?: keyof typeof decorationIcons;
}

const decorationIcons = {
    arrow: (
        <svg className={scss.decoration} xmlns='http://www.w3.org/2000/svg'>
            <use href={`${arrowRightSrc}#root`} />
        </svg>
    ),
    link: (
        <svg className={scss.decoration} xmlns='http://www.w3.org/2000/svg'>
            <use href={`${arrowLinkSrc}#root`} />
        </svg>
    ),
};

const RsnBadgeBase = (
    {color = 'neutral', decoration, className = '', ...props}: RsnBadgeProps,
    size: Modifier<'size'>
) => (
    <span {...props} className={`${className} ${scss.base} ${scss[`size--${size}`]} ${scss[`color--${color}`]}`}>
        {props.children} {decoration && decorationIcons[decoration]}
    </span>
);

namespace RsnBadge {
    export type Props = RsnBadgeProps;
}

const Md: FC<RsnBadgeProps> = props => RsnBadgeBase(props, 'normal');
Md.displayName = 'RsnBadge.Md';

const Sm: FC<RsnBadgeProps> = props => RsnBadgeBase(props, 'small');
Sm.displayName = 'RsnBadge.Sm';

const RsnBadge = {Md, Sm};

export default RsnBadge;
